import React from "react";

import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useToast,
} from "@chakra-ui/react";

import { useDeleteCollaborator } from "hooks/collaborators";

const DeleteCollaborator = ({ collaborator, closeModal, isOpen }) => {
  const toast = useToast();

  const [removeCollaborator, { isLoading }] = useDeleteCollaborator(
    {
      onSuccess: () => {
        toast({
          title: "Colaborador removido com sucesso.",
          status: "success",
          duration: 5000,
          isClosable: true,
        }),
          closeModal();
      },
      onError: () => {
        toast({
          title: "Ocorreu um erro.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      },
    }
  );

  return (
    <Modal
      isCentered
      onClose={() => closeModal()}
      isOpen={isOpen}
      motionPreset="slideInBottom"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Deletar Colaborador</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          Tem certeza que deseja remover #{collaborator?.name}
        </ModalBody>
        <ModalFooter>
          <Button mr={3} variant="ghost" onClick={() => closeModal()}>
            Cancelar
          </Button>
          <Button
            isLoading={isLoading}
            colorScheme="red"
            onClick={() => removeCollaborator({variables: {id: collaborator?.id}})}
          >
            Confirmar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DeleteCollaborator;
